<template>
  <v-container
    class="bg bg--gray"
    fill-height
    fluid
  >
    <SessionExpiresWarning />
    <LoginAttemptsWarning :attemptsRemaining="attemptsRemaining" />

    <LoginBox>
      <LoginForm
        v-if="loginBox"
        @toggleForm="toggleForm"
        @setAttemptsRemaining="setAttemptsRemaining"
      />

      <ForgotPasswordForm
        v-if="forgotPasswordBox"
        @toggleForm="toggleForm"
      />
    </LoginBox>
  </v-container>
</template>

<script>
import session from '@/services/modules/session'
import SessionExpiresWarning from 'components/pages/login/SessionExpiresWarning'
import LoginAttemptsWarning from 'components/pages/login/LoginAttemptsWarning'
import LoginForm from 'components/pages/login/LoginForm'
import ForgotPasswordForm from 'components/pages/login/ForgotPasswordForm'

export default {
  name: 'LoginPage',
  components: {
    SessionExpiresWarning,
    LoginAttemptsWarning,
    LoginForm,
    ForgotPasswordForm
  },
  data () {
    return {
      loginBox: true,
      forgotPasswordBox: false,
      attemptsRemaining: ''
    }
  },
  methods: {
    toggleForm () {
      this.loginBox = !this.loginBox
      this.forgotPasswordBox = !this.forgotPasswordBox
      this.setAttemptsRemaining('')
    },

    setAttemptsRemaining (attempt) {
      this.attemptsRemaining = attempt
    },

    resetUserSession () {
      session.logout()
    }
  },
  created () {
    this.resetUserSession()
  }
}
</script>
